export const INDIA_COUNTRY_NAME = "India";
export const DEFAULT_COUNTRY_NAME = "United States";

export const OFFICE_LOCATIONS = {
  india: {
    key: "india",
    label: "India Branch",
    country: "India",
    phone: {
      display: "+91-7030055128",
      href: "tel:+917030055128",
    },
    address:
      "Shree Chaitanya Apartment, A/09, Shiv Darshan Rd, near Muktangan English School & Junior College, Vrindavan Society, Parvati, Pune, Maharashtra 411009, India",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=Shree%20Chaitanya%20Apartment%20A%2F09%20Shiv%20Darshan%20Rd%20Parvati%20Pune%20Maharashtra%20411009%20India",
  },
  usa: {
    key: "usa",
    label: "USA Office",
    country: "United States",
    // USA phone is intentionally hidden until an official number is added.
    phone: null,
    address: "3025 Windy Knoll Ct, Suite #100, Rockville, MD 20850, USA",
    mapsUrl:
      "https://www.google.com/maps/search/?api=1&query=3025%20Windy%20Knoll%20Ct%20Suite%20100%20Rockville%20MD%2020850%20USA",
  },
};

export const getOfficeForCountry = (countryName) =>
  countryName === INDIA_COUNTRY_NAME
    ? OFFICE_LOCATIONS.india
    : OFFICE_LOCATIONS.usa;
